export default {
	addSalary: 'إضافة رواتب',
	'calculate-salaries-for-selected-month': 'احتساب رواتب الشهر',
	exportToExcel: 'تصدير إلى إكسل',

	'salary-details': 'تفاصيل الراتب',

	'recompenses': 'البدلات',
	'deductions': 'الاقتطاعات',

	'final-salary': 'الراتب النهائي'
};
